import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Services from './pages/Services';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';

// Admin Pages
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProjects from './pages/admin/AdminProjects';
import AdminFiles from './pages/admin/AdminFiles';
import AdminContact from './pages/admin/AdminContact';
import AdminRequests from './pages/admin/AdminRequests';
import AdminGallery from './pages/admin/AdminGallery';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminBlog from './pages/admin/AdminBlog';
import AdminFAQ from './pages/admin/AdminFAQ';
import AdminCareers from './pages/admin/AdminCareers';
import { ContactProvider } from './contexts/ContactContext';
// New Pages
import SignatureTower from './pages/SignatureTower';
import OurPresence from './pages/OurPresence';
import Gallery from './pages/Gallery';
import Testimonials from './pages/Testimonials';
import Blog from './pages/Blog';
import FAQ from './pages/FAQ';
import NRI from './pages/NRI';
import Partner from './pages/Partner';
import BookVisit from './pages/BookVisit';
import Brochure from './pages/Brochure';
import LegalDocs from './pages/LegalDocs';
import Landing from './pages/Landing';
import InvestorRelations from './pages/InvestorRelations';
import ThankYou from './pages/ThankYou';

// ScrollToTop component to ensure page scrolls to top on navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <ContactProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          <Route path="/admin">
            <Route path="login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="files" element={<AdminFiles />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="requests" element={<AdminRequests />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="faq" element={<AdminFAQ />} />
              <Route path="careers" element={<AdminCareers />} />
            </Route>
          </Route>
          
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="projects" element={<Projects />} />
            <Route path="services" element={<Services />} />
            <Route path="investors" element={<InvestorRelations />} />
            <Route path="careers" element={<Careers />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsOfService />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            
            {/* New Routes */}
            <Route path="signature-tower" element={<SignatureTower />} />
            <Route path="our-presence" element={<OurPresence />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="blog" element={<Blog />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="nri" element={<NRI />} />
            <Route path="partner" element={<Partner />} />
            <Route path="book-visit" element={<BookVisit />} />
            <Route path="brochure" element={<Brochure />} />
            <Route path="legal" element={<LegalDocs />} />
            <Route path="landing" element={<Landing />} />
            <Route path="thank-you" element={<ThankYou />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ContactProvider>
    </HelmetProvider>
  );
}

export default App;
